<template>
  <div class="login-page flex-grow-1">
    <b-overlay
      no-wrap
      :show="loader"
      rounded="sm"
      variant="white"
      opacity=".85"
      blur="4px"
      :fixed="true"
    >
    </b-overlay>
    <b-container class="d-flex h-100 justify-content-center align-items-center">
      <div
        v-if="pageMessage"
        class="col-md-8 flex-column align-items-center justify-content-center text-center"
      >
        <p>{{ pageMessage }}</p>
        <p>
          <router-link to="/login" class="btn btn-link">
            Страница входа
          </router-link>
          <router-link to="/register" class="btn btn-link">
            Регистрация
          </router-link>
          <router-link to="/" class="btn btn-link">Главная</router-link>
        </p>
      </div>
    </b-container>
  </div>
</template>

<script>
import msg from '@/utils/messages';

export default {
  metaInfo() {
    return {
      title: msg.PAGE_TITLE_REGISTER_CONFIRM,
      titleTemplate: `%s ${this.siteName || ''}`
    };
  },
  data() {
    return {
      loader: true,
      pageMessage: false
    };
  },
  computed: {
    siteName() {
      return this.$store.getters.getSiteParams?.siteName;
    }
  },
  async mounted() {
    try {
      const token = this.$route.query.t;
      if (token) {
        const response = await this.$store.dispatch('registerConfirm', token);
        if (response) {
          this.$router.push(`/login?msg=${msg.SUCCESS_COMFIRM_EMAIL}`);
        }
      }
      this.pageMessage = msg.ERROR_COMFIRM_EMAIL;
      this.loader = false;
    } catch (e) {
      this.loader = false;
      this.pageMessage = e.response.data.message;
    }
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  background-color: #f5f5f5;
}
</style>
